import {Injectable} from "@angular/core";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {EndpointService} from "./endpoint.service";
import {AutoOrderPaymentsResponse, AutoOrderResponse} from "../responses/AutoOrderResponse";
import {Patch} from "../models/patch";
import {BaseResponse} from "../responses/BaseResponse";
import {AutoOrderPostModel} from "../models/auto-order";

@Injectable({
  providedIn: 'root'
})
export class AutoOrderService {

  constructor(private http: HttpClient) {
  }

  public getAutoOrder(userId: string, benefitId: number, beneficiaryId?: number): Observable<AutoOrderResponse> {
    let params = new HttpParams()
      .set('userId', userId)
      .set('benefitId', benefitId.toString());

    if (beneficiaryId != null) {
      params = params.set('beneficiaryId', beneficiaryId.toString());
    }

    return this.http.get<AutoOrderResponse>(EndpointService.getAutoOrder, { params });
  }

  public getAutoOrderPayments(autoOrderId: number): Observable<AutoOrderPaymentsResponse> {
    return this.http.get<AutoOrderPaymentsResponse>(EndpointService.getAutoOrderPayments(autoOrderId), {});
  }

  public createAutoOrder(autoOrderPostModel: AutoOrderPostModel){
    return this.http.post<BaseResponse>(EndpointService.createAutoOrder, autoOrderPostModel);
  }

  public updateAutoOrder(autoOrderId: number, autoOrderPatchValues: Array<Patch>) {
    return this.http.patch<BaseResponse>(EndpointService.updateAutoOrder(autoOrderId), autoOrderPatchValues);
  }
}
